var map = {
	"./arrow-triangle.svg": "0fab",
	"./art.svg": "fe20",
	"./b.svg": "c8c9",
	"./bin.svg": "6d5c",
	"./bot.svg": "3580",
	"./contrast.svg": "acd7",
	"./dazzle-4circles.svg": "0433",
	"./dazzle-bars.svg": "7f3a",
	"./dazzle-big-circle.svg": "8086",
	"./dazzle-corners.svg": "3fd9",
	"./dazzle-cross.svg": "5396",
	"./dazzle-diamond.svg": "0897",
	"./dazzle-embeded.svg": "266c",
	"./dazzle-full-square.svg": "0a87",
	"./dazzle-half-circle.svg": "b7f4",
	"./dazzle-losange.svg": "1579",
	"./dazzle-med-cross.svg": "f4cb",
	"./dazzle-propeller.svg": "1f38",
	"./dazzle-pyramid.svg": "ab60",
	"./dazzle-quarter-round.svg": "2066",
	"./dazzle-quarter-triangle.svg": "4c1b",
	"./dazzle-ramp.svg": "db41",
	"./dazzle-sandtimer.svg": "8708",
	"./dazzle-solo-circle.svg": "4f5a",
	"./dazzle-star-propeller.svg": "f62e",
	"./dazzle-star.svg": "fadc",
	"./dazzle-stripes-1.svg": "d387",
	"./psycheSlider.svg": "125e",
	"./qr-code.svg": "3a65",
	"./rainbow.svg": "4b27",
	"./rotor.svg": "02fc",
	"./saphir.svg": "d81b",
	"./snake.svg": "1fff",
	"./theme.svg": "6230",
	"./tictac.svg": "835e",
	"./waves.svg": "7540",
	"./z.svg": "8b86"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";